//
//

import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import SCFunctionVariables from "../SCFunctionVariables/SCFunctionVariables.vue";
import SCFunctionDetails from "../SCFunctionDetails/SCFunctionDetails.vue";

export default {
    name: "ScEditAddFunction",
    components: {
        SCFunctionVariables,
        SCFunctionDetails,
        AQCard
    },
    props: {
        data: Object,
        activeTab: String,
        functId: String,
        ddlType: Array,
        functionEditMode: { type: Boolean, default: false },
        contractDetails: { type: Object, default: () => {} }
    },
    data() {
        return {
            selectedTab: "details",
            mutableData: { ...this.data },
            myFormModel: {}
        };
    },
    computed: {
        returnFunctionId() {
            return this.mutableData.id || this.functId;
        }
    },

    methods: {
        getMutableData() {
            const data = this.mutableData;
            if (this.$refs.params) {
                data.inParameters = this.$refs.params.mutableData;
            }
            if (this.$refs.returns) {
                data.outParameters = this.$refs.returns.mutableData;
            }
            [...(data.inParameters || []), ...(data.outParameters || [])].forEach(param => {
                if (!param.functionId) {
                    param.functionId = this.functId;
                }
            });
            return data;
        },
        saveData(value) {
            switch (this.selectedTab) {
                case "details":
                    this.mutableData = value;
                    break;
                case "params":
                    this.mutableData.inParameters = value;
                    break;
                case "returns":
                    this.mutableData.outParameters = value;
                    break;
                default:
            }
            if (!this.mutableData.id) {
                this.mutableData.id = this.functId;
            }
            this.$emit("dataForFunction", this.mutableData);
        }
    }
};
